// First, create an array of entries we want to display
var customermap = [
// Permanent entries
{ title: 'Shanghai, China', location: new google.maps.LatLng(31.0456, 121.3997) },
// Generated from License info
{ title: 'Aberdeen, UK', location: new google.maps.LatLng(57.1333, -2.1000) },
{ title: 'Allentown, Pennsylvania, USA', location: new google.maps.LatLng(40.5678, -75.4828) },
{ title: 'Alma, Michigan, USA', location: new google.maps.LatLng(43.3792, -84.6671) },
{ title: 'Amsterdam, Netherlands', location: new google.maps.LatLng(52.3500, 4.9167) },
{ title: 'Anchorage, AK, USA', location: new google.maps.LatLng(61.1886, -149.8878) },
{ title: 'Antwerp, Belgium', location: new google.maps.LatLng(51.2167, 4.4167) },
{ title: 'Artarmon, Australia', location: new google.maps.LatLng(-33.8167, 151.1833) },
{ title: 'Auckland, New Zealand', location: new google.maps.LatLng(-36.8667, 174.7667) },
{ title: 'Aurora, IL, USA', location: new google.maps.LatLng(41.7590, -88.2615) },
{ title: 'Austin, TX, USA', location: new google.maps.LatLng(30.3042, -97.6857) },
{ title: 'Bankstown, Australia', location: new google.maps.LatLng(-33.9224, 151.0231) },
{ title: 'Beaconsfield, UK', location: new google.maps.LatLng(51.6000, -0.6333) },
{ title: 'Beaverton, OR, USA', location: new google.maps.LatLng(45.4962, -122.8019) },
{ title: 'Belmont, NC, USA', location: new google.maps.LatLng(35.2178, -81.0394) },
{ title: 'Bensalem, PA, USA', location: new google.maps.LatLng(40.1030, -74.9415) },
{ title: 'Blenheim, New Zealand', location: new google.maps.LatLng(42.3333, -82.0000) },
{ title: 'Boca Raton, FL, USA', location: new google.maps.LatLng(26.3818, -80.1046) },
{ title: 'Boulder, CO, USA', location: new google.maps.LatLng(40.0507, -105.2037) },
{ title: 'Bracknell, UK', location: new google.maps.LatLng(51.4162, -0.7349) },
{ title: 'Brampton, ON, Canada', location: new google.maps.LatLng(43.6885, -79.7616) },
{ title: 'Brisbane, Australia', location: new google.maps.LatLng(-27.4650, 153.0234) },
{ title: 'Bristol, CT, USA', location: new google.maps.LatLng(41.6816, -72.9405) },
{ title: 'Brooklyn, Australia', location: new google.maps.LatLng(-33.5490, 151.2249) },
{ title: 'Brussels, Belgium', location: new google.maps.LatLng(50.8333, 4.3333) },
{ title: 'Burlington, Ontario, Canada', location: new google.maps.LatLng(43.3274, -79.7989) },
{ title: 'Burnaby, BC, Canada', location: new google.maps.LatLng(49.2500, -122.9500) },
{ title: 'Buxton, UK', location: new google.maps.LatLng(53.2500, -1.9167) },
{ title: 'Cali, Colombia', location: new google.maps.LatLng(3.4372, -76.5225) },
{ title: 'Cambridge, ON, Canada', location: new google.maps.LatLng(43.3833, -80.3167) },
{ title: 'Cambridge, UK', location: new google.maps.LatLng(52.2000, 0.1167) },
{ title: 'Cannington, Australia', location: new google.maps.LatLng(-32.0167, 115.9500) },
{ title: 'Cape Town, South Africa', location: new google.maps.LatLng(-33.9258, 18.4232) },
{ title: 'Cary, NC, USA', location: new google.maps.LatLng(35.7509, -78.7789) },
{ title: 'Castleton, VT, USA', location: new google.maps.LatLng(43.6603, -73.1664) },
{ title: 'Chaska, MN, USA', location: new google.maps.LatLng(44.8054, -93.6248) },
{ title: 'Chatswood, Australia', location: new google.maps.LatLng(-33.7965, 151.1718) },
{ title: 'Chatsworth, CA, USA', location: new google.maps.LatLng(34.2868, -118.6140) },
{ title: 'Cheltenham, UK', location: new google.maps.LatLng(51.9477, -2.0580) },
{ title: 'Chennai, India', location: new google.maps.LatLng(13.0833, 80.2833) },
{ title: 'Chicago, IL, USA', location: new google.maps.LatLng(41.8998, -87.6368) },
{ title: 'Christchurch, New Zealand', location: new google.maps.LatLng(-43.5333, 172.6333) },
{ title: 'Clifford, ON, Canada', location: new google.maps.LatLng(43.9666, -80.9757) },
{ title: 'Clifton Hill, Australia', location: new google.maps.LatLng(-37.8000, 144.9833) },
{ title: 'Cohuna, Australia', location: new google.maps.LatLng(-35.8000, 144.2000) },
{ title: 'Columbia City, Indiana, USA', location: new google.maps.LatLng(41.1532, -85.4810) },
{ title: 'Columbus, Ohio, USA', location: new google.maps.LatLng(39.8928, -82.9588) },
{ title: 'Corona, California, USA', location: new google.maps.LatLng(33.8357, -117.5017) },
{ title: 'Dallas, Texas, USA', location: new google.maps.LatLng(32.7673, -96.7776) },
{ title: 'Dandenong, Australia', location: new google.maps.LatLng(-38.0115, 145.2156) },
{ title: 'Dar es Salaam, Tanzania', location: new google.maps.LatLng(-5.2500, 38.8333) },
{ title: 'Dayton, OH, USA', location: new google.maps.LatLng(39.6869, -84.1641) },
{ title: 'Delson, QC, Canada', location: new google.maps.LatLng(45.3667, -73.5500) },
{ title: 'Denver, CO, USA', location: new google.maps.LatLng(39.7041, -104.9339) },
{ title: 'Dorset, UK', location: new google.maps.LatLng(45.2333, -78.8833) },
{ title: 'Dubai, UAE', location: new google.maps.LatLng(25.2582, 55.3047) },
{ title: 'Dunedin, New Zealand', location: new google.maps.LatLng(-45.8667, 170.5000) },
{ title: 'Eagle Farm, Australia', location: new google.maps.LatLng(-27.4278, 153.0500) },
{ title: 'Edinburgh, UK', location: new google.maps.LatLng(55.9500, -3.2000) },
{ title: 'Edmundston, New Brunswick, Canada', location: new google.maps.LatLng(47.3623, -68.3279) },
{ title: 'Eight Mile Plains, Australia', location: new google.maps.LatLng(-27.5833, 153.1000) },
{ title: 'Elmhurst, IL, USA', location: new google.maps.LatLng(41.8917, -87.9359) },
{ title: 'Erie, PA, USA', location: new google.maps.LatLng(42.1195, -80.0788) },
{ title: 'Fall River, WI, USA', location: new google.maps.LatLng(43.4208, -89.0512) },
{ title: 'Farnham, UK', location: new google.maps.LatLng(51.2000, -0.8000) },
{ title: 'Fenton, MO, USA', location: new google.maps.LatLng(38.4981, -90.4600) },
{ title: 'Flint, Michigan, USA', location: new google.maps.LatLng(43.0116, -83.6578) },
{ title: 'Florham Park, NJ, USA', location: new google.maps.LatLng(40.7747, -74.3980) },
{ title: 'Frankfort, MI, USA', location: new google.maps.LatLng(44.6172, -86.1820) },
{ title: 'Franklin Park, IL, USA', location: new google.maps.LatLng(40.4452, -74.5587) },
{ title: 'Gisborne, New Zealand', location: new google.maps.LatLng(-38.6533, 178.0042) },
{ title: 'Glen Allen, Virginia, USA', location: new google.maps.LatLng(37.7089, -77.5437) },
{ title: 'Glen Waverley, Australia', location: new google.maps.LatLng(-37.9000, 145.1833) },
{ title: 'Grand Island, NE, USA', location: new google.maps.LatLng(40.9250, -98.3420) },
{ title: 'Greenwood, SC, USA', location: new google.maps.LatLng(34.1954, -82.1618) },
{ title: 'Guadalajara, Mexico', location: new google.maps.LatLng(32.5442, -114.8647) },
{ title: 'Hamilton, New Zealand', location: new google.maps.LatLng(43.2561, -79.8575) },
{ title: 'Hamilton, ON, Canada', location: new google.maps.LatLng(43.2561, -79.8575) },
{ title: 'Harrison, OH, USA', location: new google.maps.LatLng(39.2486, -84.7313) },
{ title: 'Harrow, UK', location: new google.maps.LatLng(51.5667, -0.3333) },
{ title: 'Hastings, New Zealand', location: new google.maps.LatLng(44.3000, -77.9500) },
{ title: 'Herkimer, NY, USA', location: new google.maps.LatLng(43.0762, -75.0061) },
{ title: 'Hermosillo, Mexico', location: new google.maps.LatLng(32.5103, -114.9233) },
{ title: 'Hobart, Australia', location: new google.maps.LatLng(-42.8973, 147.2918) },
{ title: 'Houston, TX, USA', location: new google.maps.LatLng(29.7431, -95.4446) },
{ title: 'Indianapolis , Indiana, USA', location: new google.maps.LatLng(39.8950, -86.1804) },
{ title: 'Jamestown, NY, USA', location: new google.maps.LatLng(42.1045, -79.2520) },
{ title: 'Jette, Belgium', location: new google.maps.LatLng(50.8667, 4.3333) },
{ title: 'Johannesburg, South Africa', location: new google.maps.LatLng(-26.2052, 28.0498) },
{ title: 'Kansas City, MO, USA', location: new google.maps.LatLng(39.0362, -94.5950) },
{ title: 'Kew Gardens, NY, USA', location: new google.maps.LatLng(40.7087, -73.8268) },
{ title: 'Kitchener, ON, Canada', location: new google.maps.LatLng(43.4470, -80.4725) },
{ title: 'Mukilteo, WA, USA', location: new google.maps.LatLng(47.9130, -122.3042) },
{ title: 'La Vergne, TN, USA', location: new google.maps.LatLng(35.8596, -86.4210) },
{ title: 'Lagos, Nigeria', location: new google.maps.LatLng(6.4531, 3.3958) },
{ title: 'Lane Cove, Australia', location: new google.maps.LatLng(-33.8163, 151.1618) },
{ title: 'Lara, Venezuela', location: new google.maps.LatLng(7.2667, -68.4000) },
{ title: 'Laval, QC, Canada', location: new google.maps.LatLng(45.6167, -73.7500) },
{ title: 'Lebanon, TN, USA', location: new google.maps.LatLng(36.2788, -86.2712) },
{ title: 'Lidcombe, Australia', location: new google.maps.LatLng(-33.8554, 151.0541) },
{ title: 'Lincoln, NE, USA', location: new google.maps.LatLng(40.8756, -96.8154) },
{ title: 'London, UK', location: new google.maps.LatLng(51.5142, -0.0931) },
{ title: 'Long Valley, New Jersey, USA', location: new google.maps.LatLng(40.7843, -74.8060) },
{ title: 'Louisville, KY, USA', location: new google.maps.LatLng(38.2517, -85.7544) },
{ title: 'Loveland, CO, USA', location: new google.maps.LatLng(40.3532, -105.1316) },
{ title: 'Lurgan, N. Ireland', location: new google.maps.LatLng(53.2017, -8.3550) },
{ title: 'Macau, Macau', location: new google.maps.LatLng(22.2000, 113.5500) },
{ title: 'Malvern, UK', location: new google.maps.LatLng(52.1167, -2.3167) },
{ title: 'Markham, ON, Canada', location: new google.maps.LatLng(43.8770, -79.2578) },
{ title: 'Mason, Ohio, USA', location: new google.maps.LatLng(39.3522, -84.2994) },
{ title: 'Melbourne, Australia', location: new google.maps.LatLng(-37.8232, 144.9729) },
{ title: 'Menomonee Falls, WI, USA', location: new google.maps.LatLng(43.1789, -88.1173) },
{ title: 'Milwaukee, WI, USA', location: new google.maps.LatLng(43.1409, -87.9497) },
{ title: 'Minneapolis, MN, USA', location: new google.maps.LatLng(45.0636, -93.3789) },
{ title: 'Mississauga, ON, Canada', location: new google.maps.LatLng(43.6000, -79.6500) },
{ title: 'Mochau, Germany', location: new google.maps.LatLng(51.1333, 13.1833) },
{ title: 'Monclova, Mexico', location: new google.maps.LatLng(20.1700, -100.6914) },
{ title: 'Monterrey, Mexico', location: new google.maps.LatLng(20.6542, -98.1500) },
{ title: 'Mountain View, CA, USA', location: new google.maps.LatLng(37.4192, -122.0574) },
{ title: 'Nairobi, Kenya', location: new google.maps.LatLng(-1.2833, 36.8167) },
{ title: 'Napier, New Zealand', location: new google.maps.LatLng(-39.4833, 176.9167) },
{ title: 'Nashville, TN, USA', location: new google.maps.LatLng(36.1680, -86.7817) },
{ title: 'Nelson, New Zealand', location: new google.maps.LatLng(49.4833, -117.2833) },
{ title: 'New Westminster, BC, Canada', location: new google.maps.LatLng(49.2167, -122.9167) },
{ title: 'New York, NY, USA', location: new google.maps.LatLng(40.7214, -74.0052) },
{ title: 'Newark, NY, USA', location: new google.maps.LatLng(43.0719, -77.0976) },
{ title: 'North Kingstown, RI, USA', location: new google.maps.LatLng(41.5501, -71.4662) },
{ title: 'North Shore, New Zealand', location: new google.maps.LatLng(-36.8000, 174.7500) },
{ title: 'Nyon, Switzerland', location: new google.maps.LatLng(46.3888, 6.2393) },
{ title: 'Oostburg, WI, USA', location: new google.maps.LatLng(43.6150, -87.8060) },
{ title: 'Ouddorp, Netherlands', location: new google.maps.LatLng(51.8171, 3.9345) },
{ title: 'Oxford, UK', location: new google.maps.LatLng(51.7500, -1.2500) },
{ title: 'Palm Beach Gardens, FL, USA', location: new google.maps.LatLng(26.8234, -80.1386) },
{ title: 'Palmerston North, New Zealand', location: new google.maps.LatLng(-40.3500, 175.6167) },
{ title: 'Pasig City, Philippines', location: new google.maps.LatLng(14.5604, 121.0812) },
{ title: 'Perth, Australia', location: new google.maps.LatLng(-31.9522, 115.8614) },
{ title: 'Phoenix, AZ, USA', location: new google.maps.LatLng(33.4319, -112.0150) },
{ title: 'Pietermaritzburg, South Africa', location: new google.maps.LatLng(-29.6167, 30.3833) },
{ title: 'Pittsburgh, PA, USA', location: new google.maps.LatLng(40.4426, -79.9770) },
{ title: 'Plymouth, MI, USA', location: new google.maps.LatLng(42.3655, -83.5367) },
{ title: 'Queenstown, New Zealand', location: new google.maps.LatLng(-45.0100, 168.4000) },
{ title: 'Quesnel, BC, Canada', location: new google.maps.LatLng(52.9833, -122.4833) },
{ title: 'R�ttvik, Sweden', location: new google.maps.LatLng(60.8863, 15.1179) },
{ title: 'Redditch, UK', location: new google.maps.LatLng(52.2745, -1.9302) },
{ title: 'Reed City, MI, USA', location: new google.maps.LatLng(43.8901, -85.5036) },
{ title: 'Richmond, BC, Canada', location: new google.maps.LatLng(37.4677, -77.5900) },
{ title: 'Richmond, KY, USA', location: new google.maps.LatLng(37.7666, -84.3031) },
{ title: 'Road Town, British Virgin Islands', location: new google.maps.LatLng(18.4167, -64.6167) },
{ title: 'Rochester Hills, MI, USA', location: new google.maps.LatLng(42.6584, -83.1499) },
{ title: 'Ross On Wye, UK', location: new google.maps.LatLng(51.9167, -2.5667) },
{ title: 'Salt Lake City, Utah, USA', location: new google.maps.LatLng(40.7855, -111.7367) },
{ title: 'San Angel, Mexico', location: new google.maps.LatLng(19.3733, -99.2250) },
{ title: 'San Antonio, TX, USA', location: new google.maps.LatLng(29.4889, -98.3987) },
{ title: 'San Diego, CA, USA', location: new google.maps.LatLng(32.8594, -117.2073) },
{ title: 'San Jose, California, USA', location: new google.maps.LatLng(37.2555, -121.9245) },
{ title: 'Schiller Park, IL, USA', location: new google.maps.LatLng(41.9637, -87.8841) },
{ title: 'Seattle, Washington, USA', location: new google.maps.LatLng(47.6103, -122.3341) },
{ title: 'Singapore, Singapore', location: new google.maps.LatLng(1.2931, 103.8558) },
{ title: 'Skelmersdale, UK', location: new google.maps.LatLng(53.5135, -2.7566) },
{ title: 'South Bend, IN, USA', location: new google.maps.LatLng(41.6727, -86.2513) },
{ title: 'South Windsor, Conneticut, USA', location: new google.maps.LatLng(41.8338, -72.5706) },
{ title: 'Southwark, UK', location: new google.maps.LatLng(51.5000, -0.0833) },
{ title: 'St Louis, MO, USA', location: new google.maps.LatLng(38.6273, -90.1979) },
{ title: 'Sunrise, Florida, USA', location: new google.maps.LatLng(26.1577, -80.2861) },
{ title: 'Sussex, WI, USA', location: new google.maps.LatLng(43.1488, -88.2451) },
{ title: 'Suva, Fiji', location: new google.maps.LatLng(-18.1333, 178.4167) },
{ title: 'Sydney, Australia', location: new google.maps.LatLng(-33.8615, 151.2055) },
{ title: 'Taumarunui, New Zealand', location: new google.maps.LatLng(-38.8833, 175.2617) },
{ title: 'Tauranga, New Zealand', location: new google.maps.LatLng(-37.6861, 176.1667) },
{ title: 'Te Anau, New Zealand', location: new google.maps.LatLng(-45.4167, 167.7167) },
{ title: 'Thames, New Zealand', location: new google.maps.LatLng(-37.1333, 175.5333) },
{ title: 'TOMAGO, Australia', location: new google.maps.LatLng(-32.8333, 151.7333) },
{ title: 'Toronto, Australia', location: new google.maps.LatLng(-33.0000, 151.6000) },
{ title: 'Toronto, ON, Canada', location: new google.maps.LatLng(43.6667, -79.4167) },
{ title: 'Torrance, California, USA', location: new google.maps.LatLng(33.8302, -118.3147) },
{ title: 'Troy, Michigan, USA', location: new google.maps.LatLng(42.5983, -83.1785) },
{ title: 'Utrecht, Netherlands', location: new google.maps.LatLng(52.0500, 5.2583) },
{ title: 'Vancouver, BC, Canada', location: new google.maps.LatLng(49.2500, -123.1333) },
{ title: 'Vianen, Netherlands', location: new google.maps.LatLng(51.7180, 5.8500) },
{ title: 'Wanganui, New Zealand', location: new google.maps.LatLng(-39.9333, 175.0500) },
{ title: 'Warsaw, IN, USA', location: new google.maps.LatLng(41.2023, -85.8630) },
{ title: 'Warwick, UK', location: new google.maps.LatLng(52.2833, -1.5833) },
{ title: 'Watchfield, UK', location: new google.maps.LatLng(51.2192, -2.9353) },
{ title: 'Waterloo, ON, Canada', location: new google.maps.LatLng(43.4665, -80.5023) },
{ title: 'Watertown, MA, USA', location: new google.maps.LatLng(42.3722, -71.1787) },
{ title: 'Waukesha, WI, USA', location: new google.maps.LatLng(43.0282, -88.2949) },
{ title: 'Wellington, New Zealand', location: new google.maps.LatLng(-41.3000, 174.7833) },
{ title: 'Wellsville, NY, USA', location: new google.maps.LatLng(42.0908, -77.9477) },
{ title: 'Westfield, MA, USA', location: new google.maps.LatLng(42.1733, -72.7715) },
{ title: 'Westminster, California, USA', location: new google.maps.LatLng(33.7474, -117.9939) },
{ title: 'Whakatane, New Zealand', location: new google.maps.LatLng(-37.9833, 177.0000) },
{ title: 'Whangarei, New Zealand', location: new google.maps.LatLng(-35.7200, 174.3300) },
{ title: 'Whippany, NJ, USA', location: new google.maps.LatLng(40.8673, -74.5783) },
{ title: 'Wichita, KS, USA', location: new google.maps.LatLng(37.7068, -97.2787) },
{ title: 'Willowbrook, IL, USA', location: new google.maps.LatLng(41.7439, -87.9343) },
{ title: 'Windsor, Ontario, Canada', location: new google.maps.LatLng(42.3016, -83.0307) },
{ title: 'Woodinville, WA, USA', location: new google.maps.LatLng(47.7543, -122.1635) },
{ title: 'Woodstock, IL, USA', location: new google.maps.LatLng(42.3222, -88.4671) },
{ title: 'Wytheville, Virginia, USA', location: new google.maps.LatLng(36.9498, -81.1289) },
{ title: 'Yellow Springs, OH, USA', location: new google.maps.LatLng(39.7949, -83.8873) },
{ title: 'Zoetermeer, Netherlands', location: new google.maps.LatLng(52.0537, 4.4924) }
];

function addcustomermarkers() {
    "use strict";

    // center and zoom the map so it shows the whole world
    var mapOptions = {
        center: { lat: 12.00, lng: 35.00}, 
        zoom: 2
    };

    // create the map 
    var map = new google.maps.Map(document.getElementById('map-canvas'), mapOptions);

    // define the marker
    var image = {
        url: 'images/marker.png',
        size: new google.maps.Size(22, 24), 
        origin: new google.maps.Point(0,0),
        anchor: new google.maps.Point(0, 23) 
    };

    // define the clickable area
    var shape = {
      coords: [14, 8, 8],
      type: 'circle'
    };

    // add a marker for each entry.
    for (var city in customermap) {
        var marker = new google.maps.Marker({
            position: customermap[city].location,
            map: map,
            icon: image,
            shape: shape,
            title: customermap[city].title
        });
    }
}

$(function () {
    "use strict";

    addcustomermarkers();
});
